import { useState, useRef } from "react";
import cn from "classnames";
import DatePicker from "@ui-kit/DatePicker/DatePicker";
import { usePopper } from "react-popper";
import { useClickAway } from "react-use";
import s from "./DayPicker.module.scss";

const DatePickerField = ({
  className,
  triggerElement,
  popperContentProps,
  placement = "bottom-start",
}) => {
  const [isPopperOpen, setIsPopperOpen] = useState(false);

  const elementRef = useRef(null);
  const popperRef = useRef(null);
  const [popperElement, setPopperElement] = useState(null);

  const popper = usePopper(elementRef.current, popperElement, {
    placement,
  });

  const closePopper = () => {
    setIsPopperOpen(false);
  };

  const handleButtonClick = () => {
    setIsPopperOpen(!isPopperOpen);
  };

  const handleDaySelect = (date) => {
    popperContentProps.onSelect(date);
    closePopper();
  };

  useClickAway(popperRef, () => {
    if (isPopperOpen) {
      closePopper();
    }
  });

  return (
    <div className={cn(s.field, className)}>
      <div ref={elementRef} onClick={handleButtonClick} className={s.element}>
        {triggerElement}
      </div>
      {isPopperOpen && (
        <div
          ref={(node) => {
            setPopperElement(node);
            popperRef.current = node;
          }}
          className={s.poper}
          style={popper.styles.popper}
          {...popper.attributes.popper}
        >
          <DatePicker
            mode="single"
            {...popperContentProps}
            onSelect={handleDaySelect}
            className={s.datePicker}
          />
        </div>
      )}
    </div>
  );
};

export default DatePickerField;
